import { on, select, removeClass, addClass, hasClass, selectAll, setStyle } from 'modules/dom'
import { map } from 'modules/utils'

const ACTIVATE_CLASS = 'js-loaded-item'
const DEACTIVATE_CLASS = 'js-load-item'
const SHOW_MORE_TEXT = 'Show More Resources'
const SHOW_LESS_TEXT = 'Show Less Resources'
const SHOW_LESS_CLASS = 'show-less'
const MEDIUM_BREAKPOINT = window.matchMedia('(min-width: 1000px)')
const LARGE_BREAKPOINT = window.matchMedia('(min-width: 1280px)')

function GridLoadMore (el) {
  const t = this
  t.listItems = select('.js-grid-row-list', el)
  t.button = select('.js-load-more-button', el)
  t.loadedItems = selectAll('.js-loaded-item', t.listItems)
  t.items = selectAll('.js-load-item', t.listItems)

  t.showMore()
}

GridLoadMore.prototype.showMore = function () {
  const t = this
  const activateItem = (item) => {
    addClass(ACTIVATE_CLASS, item)
    removeClass(DEACTIVATE_CLASS, item)
  }
  const deactivateItem = (item) => {
    addClass(DEACTIVATE_CLASS, item)
  }
  const loadItems = (item, index, max) => {
    if (index < max) {
      activateItem(item)
    }
  }
  const changeText = (text, e) => {
    e.innerHTML = text
  }
  const checkBreakPoint = (breakpoint) => breakpoint.matches
  const checkItems = (item, number) => item.length > number
  const showItems = (items, num) => {
    map((item, index) => {
      loadItems(item, index, num)
    }, items)
  }
  const loadItemsBegin = () => {
    if (t.items && checkBreakPoint(LARGE_BREAKPOINT)) {
      showItems(t.items, 4)
    } else if (t.items && checkBreakPoint(MEDIUM_BREAKPOINT)) {
      showItems(t.items, 3)
    } else if (t.items && !checkBreakPoint(MEDIUM_BREAKPOINT)) {
      showItems(t.items, 2)
    }
  }
  const remainItems = item => checkItems(item, 0)
  const updateTextButton = () => {
    removeClass(SHOW_LESS_CLASS, t.button)
    changeText(SHOW_MORE_TEXT, t.button)
  }
  const itemStatus = () => {
    t.items = selectAll('.js-load-item', t.listItems)
    t.loadedItems = selectAll('.js-loaded-item', t.listItems)
  }
  const setMaxHeight = setStyle('max-height')
  const initialHeightListItems = () => {
    if (t.loadedItems[0]) {
      t.height = t.loadedItems[0].scrollHeight + 20 + 'px'
      setMaxHeight(t.height, t.listItems)
    }
  }
  const setHeightListItems = () => setMaxHeight('9979px', t.listItems)
  const resetItems = (loadedItems, num) => {
    map((item, index) => {
      if (index > num) {
        deactivateItem(item)
      }
      t.items = selectAll('.js-load-item', t.listItems)
      if (t.items) {
        updateTextButton()
      }
    }, loadedItems)
    itemStatus()
    initialHeightListItems()
  }
  const initialItems = () => {
    t.loadedItems = selectAll('.js-loaded-item', t.listItems)
    deactivateItem(t.loadedItems)
    t.items = selectAll('.js-load-item', t.listItems)
    loadItemsBegin()
    initialHeightListItems()
  }
  const resize = () => !hasClass(SHOW_LESS_CLASS, t.button) && initialItems()
  on('load', () => {
    loadItemsBegin()
    itemStatus()
    initialHeightListItems()
    if (t.button) {
      if (remainItems(t.items)) {
        activateItem(t.button)
      }
      on('click', () => {
        itemStatus()
        if (remainItems(t.items)) {
          activateItem(t.items)
          itemStatus()
          setHeightListItems()
          addClass(SHOW_LESS_CLASS, t.button)
          changeText(SHOW_LESS_TEXT, t.button)
        } else if (checkBreakPoint(LARGE_BREAKPOINT)) {
          resetItems(t.loadedItems, 3)
        } else if (checkBreakPoint(MEDIUM_BREAKPOINT)) {
          resetItems(t.loadedItems, 2)
        } else if (!checkBreakPoint(MEDIUM_BREAKPOINT)) {
          resetItems(t.loadedItems, 1)
        }
      }, t.button)
    }
  }, window)
  on('resize', resize, window)
}

module.exports = GridLoadMore
